import { formatUtils } from '@elotech/components';

const MaskUtils = {
  formatCPF(value) {
    return value ? formatUtils.formatCpfCnpj(value) : value;
  },

  formatCNPJ(value) {
    return value ? formatUtils.formatCpfCnpj(value) : value;
  },

  format(value) {
    return value ? formatUtils.formatCpfCnpj(value) : value;
  },

  formatTelefone(valor) {
    if (!valor) return valor;
    valor = valor.replace(/\D/g, '');
    valor = valor.replace(/^(\d{2})(\d)/g, '($1) $2');
    valor = valor.replace(/(\d)(\d{4})$/, '$1-$2');
    return valor;
  }
};

export default MaskUtils;
